import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { template } from 'app/models/Placement/PlacementMods';
import { selectCurrentModDetails, selectIsCustomTemplateType } from 'store/redux-store/placement-mods/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { shiftDifferentialModStyles } from './ShiftDifferentialMod.style';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { TemplateTypes } from './Utils';
import { missingField } from 'app/constants';

export const Template = ({
  options,
  isModEdit,
  setTemplateChanged,
}: {
  options: any;
  isExpanded: boolean;
  isModEdit: boolean;
  setTemplateChanged: any;
}) => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext();
  const { classes } = shiftDifferentialModStyles({ isModEdit });
  const templateValue: any = useWatch({ name: template });
  const selectedModsDetails = useSelector(selectCurrentModDetails);
  const isCustomTemplateType = useSelector(selectIsCustomTemplateType);
  const dispatch = useDispatch();

  const clearErrors = () => {
    dispatch(placementModsAction.setShiftDifferentialStartTimeError([]));
    dispatch(placementModsAction.setShiftDifferentialEndTimeError([]));
    dispatch(placementModsAction.setShiftDifferentialAmountError([]));
    dispatch(placementModsAction.setShiftDifferentialTypeError([]));
    dispatch(placementModsAction.setShiftDifferentialDescriptionTypeError([]));
  };

  const handleRadioChange = e => {
    setValue(template, e.target.value);
    clearErrors();
    setTemplateChanged(true);
    if (e.target.value.toString() === TemplateTypes.Standard.toString()) {
      dispatch(placementModsAction.setCustomTemplateType(false));
    } else {
      dispatch(placementModsAction.setCustomTemplateType(true));
    }
  };

  useEffect(() => {
    if (isModEdit) {
      if (isCustomTemplateType) {
        setValue(template, TemplateTypes.Custom.toString());
      } else {
        setValue(template, TemplateTypes.Standard.toString());
      }
    }
  }, [isCustomTemplateType]);

  return (
    <Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name={template}
          render={({ field: { onChange, ...rest } }) => {
            return (
              <Grid>
                <Grid>
                  <FormControl disabled={!isModEdit}>
                    <RadioGroup
                      row
                      value={templateValue}
                      name={template}
                      onChange={e => {
                        onChange(e);
                        handleRadioChange(e);
                      }}
                    >
                      <FormLabel className={classes.templateLb}>{t('placement.placementMods.template')}</FormLabel>
                      {options &&
                        options.map(option => (
                          <FormControlLabel
                            checked={templateValue && parseInt(templateValue.toString()) === parseInt(option.ID)}
                            key={option.ID}
                            value={option.ID}
                            control={<Radio disableFocusRipple disableRipple disableTouchRipple />}
                            label={option.Description}
                            className={classes.radioLabel}
                          />
                        ))}
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid className={classes.gridRow}>
                  <Grid item xs={12}>
                    <Typography component="span" className={classes.descriptionlb}>{`${t(
                      'placement.placementMods.shiftDiffDescription',
                    )}`}</Typography>
                    <Typography component="span">
                      {!selectedModsDetails?.standard && templateValue
                        ? options.find(t => parseInt(templateValue.toString()) === parseInt(t.ID))?.Description
                        : missingField}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            );
          }}
        />
      </Grid>
    </Grid>
  );
};
